import { ReactElement, useId } from 'react';
import { ActivityField, TableInlineColumn } from 'components';
import { DecimalField } from '@ff-it/form';
import { CompanyField } from 'modules/core/company/components';
import { OutletOrServiceCategoryField } from 'modules/supplier/outletOrServiceCategory/OutletOrServiceCategoryField';
import { Icon } from '@ff-it/ui';
import { CategoryField } from 'modules/supplier/category/MediaCategoryField';
import { required } from 'utilities';
import { Tooltip } from 'react-tooltip';

export function FinalColumnHeader(): ReactElement {
  const id = useId();

  return (
    <span className="text-left">
      Final <Icon icon="circle-question" data-tooltip-id={id} />
      <Tooltip id={id}>Final rate will be used over current if present.</Tooltip>
    </span>
  );
}

const props = {
  size: 'sm' as const,
  className: 'mb-0',
};

const selectProps = {
  ...props,
  placeholder: 'All',
};

const headerCellProps = {
  textSize: 'xs',
  fontWeight: 'regular',
} as const;

const baseColumns: TableInlineColumn[] = [
  {
    key: 'category',
    content: 'Category',
    headerCellProps,
    render: ({ name }) => <CategoryField name={`${name}.category`} {...selectProps} />,
  },
  {
    key: 'activity',
    content: 'Activity',
    render: ({ name }) => <ActivityField name={`${name}.activity`} {...selectProps} />,
    headerCellProps,
  },
  {
    key: 'outlet_or_service_category',
    content: 'Outlet or service',
    render: ({ name }) => <OutletOrServiceCategoryField name={`${name}.outlet_or_service_category`} {...selectProps} />,
    headerCellProps,
  },
];

const rateColumns: TableInlineColumn[] = [
  {
    key: 'current',
    content: 'Current',
    width: '70px',
    render: ({ name }) => <DecimalField name={`${name}.current`} {...props} required validate={required} />,
    cellProps: { textAlign: 'center' },
    headerCellProps,
  },
  {
    key: 'target',
    content: 'Target',
    width: '70px',
    render: ({ name }) => <DecimalField name={`${name}.target`} {...props} />,
    cellProps: { textAlign: 'center' },
    headerCellProps,
  },
  {
    key: 'final',
    content: <FinalColumnHeader />,
    width: '70px',
    render: ({ name }) => <DecimalField name={`${name}.final`} {...props} />,
    cellProps: { textAlign: 'center' },
    headerCellProps,
  },
];

export const avb: TableInlineColumn[] = [
  ...baseColumns,
  {
    key: 'client',
    content: 'Client',
    render: ({ name }) => <CompanyField name={`${name}.client`} includeBranches {...selectProps} />,
    headerCellProps,
  },
  {
    key: 'payer',
    content: 'Payer',
    render: ({ name }) => <CompanyField name={`${name}.payer`} includeBranches {...selectProps} />,
    headerCellProps,
  },
  ...rateColumns,
];

export const cvb: TableInlineColumn[] = [
  ...baseColumns,
  {
    key: 'provider',
    content: 'Provider',
    render: ({ name }) => <CompanyField name={`${name}.provider`} includeBranches {...selectProps} />,
    headerCellProps,
  },
  ...rateColumns,
];
